import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {

                },
                url: {
                    getMenu: `${codeAPI}/front/sidebar/links`,
                },
                iframe: {
                    url: null,
                }
            },
        },
        tools: {
            backoffice: {
                active: true,
                title: 'Backoffice',
                label: 'Backoffice',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'IG_00006',
                },
                url: {
                    view: `:moduleCodegestao.home`,
                }
            },
        },
        config: {

        },
    },
};

export default state;